module.exports = __webpack_public_path__ + "img/材料力学6_7_1.4b9dbe58.jpg";